<script setup lang="ts">
const STORAGE_KEY = 'cookie-consent';
const STORAGE_VALUE = 'gave_consent';

const show = ref(false);

onMounted(() => {
    show.value = localStorage.getItem(STORAGE_KEY) !== STORAGE_VALUE;
});

const agree = () => {
    localStorage.setItem(STORAGE_KEY, STORAGE_VALUE);
    show.value = false;
};

const { url: cookieUrl } = usePublicUrl('/privacy', {
    fragment: 'cookies',
});
</script>

<template>
    <div
        v-if="show"
        class="d-flex justify-content-center align-items-center bg-white border-top border-bottom border-secondary"
        style="position: fixed; bottom: 0; left: 0; right: 0; z-index: 10000"
    >
        <div class="d-flex align-items-center gap-2 p-5">
            <span> This website uses cookies to ensure you get the best experience on our website. </span>
            <span>
                <a :href="cookieUrl" target="_blank">Learn More</a>
            </span>
            <button class="btn btn-primary" @click="agree">Got it!</button>
        </div>
    </div>
</template>

<style scoped></style>
